import React, {useState} from "react";
import {Bars} from "react-loader-spinner";
import {MUIDataTableColumnDef, MUISortOptions, SelectableRows} from "mui-datatables";
import moment from "moment";

import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";

import {ApolloAxios, ApiResponse, getResultType, isSuccessApi} from "../../atom/Apollo_ApiRequest3";
import {
  APOLLO_SYSTEM_OPERATOR,
  APOLLO_PROFILE_SYSTEM_OPERATOR,
  ApolloPageUsagePermission
} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloDataTable, DataTableOptions, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";
import {
  apollo_ad_client_icons_approval_path,
  apollo_ad_client_icon_approval_path,
} from "../../atom/Apollo_links";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {
  apollo_useStyles,
  options_reviewstatus_ad_client_icon,
  options_reviewreason_ad_client_icon,
  valueToOption,
  valueToOptionNull, 
} from "../../atom/Apollo_styles";
import {ApolloTabPanel, ApolloTabs2} from "../../atom/Apollo_Tabs"

import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";

import GenericTemplate from "../../templates/GenericTemplate";

import {AdClientIconApprovalInfo} from "./AccountModel"
import AdClientIconApprovalEdit from "./AdClientIconApprovalEdit";

const DATE_TIME_SUFFIX = "Z"
const BLANK = ""

const AdClientIconApprovalPage: React.FC = () => {

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 20,
    breadId: 3,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const classes = apollo_useStyles();
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {state} = React.useContext(ApolloContext);
  const [tabstate, setTabstate] = useState(0);
  const [unApprovedRows, setUnApprovedRows] = useState<AdClientIconApprovalInfo[]>([]);
  const [approvedRows, setApprovedRows] = useState<AdClientIconApprovalInfo[]>([]);
  const [selectAdClientIconId, setSelectAdClientIconId] = useState(0);

  const [isEditorOpen, setIsEditorOpen] = useState<boolean>(false);
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const [progress, setProgress] = useState(false);
  const beforeData = React.useRef<any>(null);
  const resultApi = React.useRef(-1);

  const DEFAULT_ROWS_PER_PAGE = 10;

  const [rowsPerPageUnapproved, setRowsPerPageUnapproved] = useState<number>(() => {
    const raw = localStorage.getItem(STORAGE_KEY.APOLLO_UNAPPROVED_AD_CLIENT_ICON);
    return raw ? (JSON.parse(raw)?.rowsPerPage ?? DEFAULT_ROWS_PER_PAGE) : DEFAULT_ROWS_PER_PAGE;
  });
  const [rowsPerPageApproved, setRowsPerPageApproved] = useState<number>(() => {
    const raw = localStorage.getItem(STORAGE_KEY.APOLLO_APPROVED_AD_CLIENT_ICON);
    return raw ? (JSON.parse(raw)?.rowsPerPage ?? DEFAULT_ROWS_PER_PAGE) : DEFAULT_ROWS_PER_PAGE;
  });

  const [adClientIconInfo, setAdClientIconInfo] = useState<AdClientIconApprovalInfo>({
    adClientIconId: 0,
    accountId: 0,
    accountName: "",
    advertiserName: "",
    industoryName: "",
    productName: "",
    adClientIconName: "",
    imageUrl: "",
    approvedAt: "",
    approval: 0,
    denialReason: 0,
    denialReasonDetail: "",
  })

  React.useEffect(() => {
    const init = async() => {
      setProgress(true);
      if (tabstate === 0) {
        await getUnApprovedAdClientIconList();
      } else if (tabstate === 1) {
        await getApprovedAdClientIconList();
      }
      setProgress(false);
    }
    init();
  }, [tabstate]);

  /** 未審査アイコン一覧取得 */
  const getUnApprovedAdClientIconList = async() => {
    await getAdClientIconApprovalList(0, setUnApprovedRows);
  }

  /** 未審査アイコン一覧取得 */
  const getApprovedAdClientIconList = async() => {
    await getAdClientIconApprovalList(1, setApprovedRows);
  }

  /** 一覧取得共通処理 */
  const getAdClientIconApprovalList = async(isApproved: number, setRows: any) => {
    setRows([])
    const url = `${apollo_ad_client_icons_approval_path}/${isApproved}`;
    await ApolloAxios.get(
      url
    ).then(response => {
      const res: ApiResponse = response.data;
      if (!isSuccessApi(res.resultCode)) {
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : "広告主アイコン審査一覧情報の取得に失敗しました",
        });
      }
      setRows(res.result ?? []);
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });
  }

  const handleOpenEditor = (row: AdClientIconApprovalInfo) => {
    setIsEditorOpen(true);
    setSelectAdClientIconId(row.adClientIconId);
    beforeData.current = row;
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    })
  }

  const handleCloseEditor = () => {
    setIsEditorOpen(false);
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
  }

  const handleSave = async(adClientIcon: AdClientIconApprovalInfo) => {
    let isSuccess = false;
    setProgress(true);

    // 操作ログ出力(編集)
    adClientIconInfo.approval = adClientIcon.approval
    adClientIconInfo.denialReason = adClientIcon.denialReason
    adClientIconInfo.denialReasonDetail = adClientIcon.denialReasonDetail
    resultApi.current = 0;
    writeLog();

    const adClientIconId = adClientIcon.adClientIconId
    if (!adClientIconId) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "広告主アイコンIDがありません",
        }
      });
    }

    const url = `${apollo_ad_client_icon_approval_path}/${adClientIconId}`;
    const reqBody = {
      approval: adClientIcon.approval,
      denialReason: adClientIcon.denialReason,
      denialReasonDetail: adClientIcon.denialReasonDetail,
    }
    await ApolloAxios.put(
      url,
      reqBody,
    ).then(response => {
      const res: ApiResponse = response.data;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: getResultType(res.resultCode),
          message: res.message,
        }
      });

      if (isSuccessApi(res.resultCode)) {
        // 操作ログ(成功)
        resultApi.current = 1;
        isSuccess = true;
      } else {
        // 操作ログ(失敗)
        resultApi.current = 9;
      }
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
    });

    setProgress(false);
    if (isSuccess) {
      handleCloseEditor();
      getUnApprovedAdClientIconList();
    }
  }

  // 操作ログ出力
  const writeLog = () => {
    if (resultApi.current < 0) return;

    const itemList1: ItemList[] = [
      {
        key: "否認結果",
        beforeValue: valueToOption(beforeData.current.approval, options_reviewstatus_ad_client_icon).label + "",
        afterValue: valueToOption(adClientIconInfo.approval, options_reviewstatus_ad_client_icon).label + "",
      },
    ]
    const itemList2: ItemList[] = [
      {
        key: "否認理由",
        beforeValue: "",
        afterValue: valueToOption(adClientIconInfo.denialReason, options_reviewreason_ad_client_icon).label + "",
      },
      {
        key: "否認詳細",
        beforeValue: "",
        afterValue: adClientIconInfo.denialReasonDetail,
      },
    ]
    var itemList: ItemList[] = [];
    if (adClientIconInfo.approval === 3) {
      itemList = itemList1.concat(itemList2);
    } else {
      itemList = itemList1;
    }

    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: resultApi.current === 0 ? "execute" : "result",
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken,
      accountGroupID: state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID: state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "",
      campaignName: "",
      adGroupID: "",
      adGroupName: "",
      menu: "",
      displayName: "広告主アイコン審査画面",
      category: "広告主アイコン",
      actionType: "更新",
      targetID: beforeData.current ? beforeData.current.adClientIconId + "" : "",
      targetName: beforeData.current ? beforeData.current.adClientIconName + "" : "",
      itemList: itemList,
    }

    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "adClientIconId",
      label: "広告主アイコンID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountId",
      label: "広告主アカウントID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "accountName",
      label: "広告主アカウント名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "advertiserName",
      label: "広告主名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "industoryName",
      label: "業種",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "productName",
      label: "商品名称",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "adClientIconName",
      label: "画像ファイル名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "imageUrl",
      label: "画像プレビュー",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: string) => {
          return value !== ""
            ? (<img src={value} alt="" style={{width: '120px', borderRadius: '50%'}}/>)
            : ("");
        }
      }
    },
    {
      name: "createdAt",
      label: "入稿日",
      options: {
        display: tabstate === 0 ? true : "excluded",
        filter: tabstate === 0 ? true : false,
        sort: true,
        customBodyRender: (value: any) => {
          return moment(value.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY/MM/DD");
        },
      }
    },
    {
      name: "approvedAt",
      label: "審査結果登録日",
      options: {
        display: tabstate === 1 ? true : "excluded",
        filter: tabstate === 1 ? true : false,
        sort: true,
        customBodyRender: (value: any) => {
          return moment(value.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY/MM/DD");
        },
      }
    },
    {
      name: "approval",
      label: "審査結果",
      options: {
        display: tabstate === 1 ? true : "excluded",
        filter: tabstate === 1 ? true : false,
        sort: true,
        customBodyRender: (value: number) => {
          return (valueToOptionNull(value, options_reviewstatus_ad_client_icon)?.label)
        },
      }
    },
    {
      name: "",
      label: tabstate === 0 ? "審査承認" : "審査詳細",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <Button
              variant="contained"
              color="primary"
              onClick={e => handleOpenEditor(tabstate === 0 ? unApprovedRows[idx] : approvedRows[idx])}
            >
              {tabstate === 0 ? "審査" : "詳細"}
            </Button>
          );
        }
      },
    },
  ]

  const sortOrder: MUISortOptions = {
    name: "adClientIconId",
    direction: tabstate === 0 ? 'asc' : 'desc',
  }
  const selectableRows: SelectableRows = 'none';
  const options: DataTableOptions = {
    filter: true,
    filterType: "multiselect",
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.APOLLO_UNAPPROVED_AD_CLIENT_ICON) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: rowsPerPageUnapproved,
    rowsPerPageOptions: [10, 25, 50],
    onChangeRowsPerPage: (n: number) => setRowsPerPageUnapproved(n),
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.APOLLO_UNAPPROVED_AD_CLIENT_ICON,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  }
  const options2: DataTableOptions = {
    ...options,
    sortOrder: localStorage.getItem(STORAGE_KEY.APOLLO_APPROVED_AD_CLIENT_ICON) ? undefined : sortOrder,
    storageKey: STORAGE_KEY.APOLLO_APPROVED_AD_CLIENT_ICON,
    rowsPerPage: rowsPerPageApproved,
    onChangeRowsPerPage: (n: number) => setRowsPerPageApproved(n),
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloPageUsagePermission role={APOLLO_SYSTEM_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
        <Backdrop className={classes.backdrop2} open={progress}>
          <Bars color="#00BFFF" height={80} width={80}/>
        </Backdrop>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>

        {isEditorOpen 
          ? <RightDrawer>
            <AdClientIconApprovalEdit
              adClientIconId={selectAdClientIconId}
              submitAction={handleSave}
              goBackAction={handleCloseEditor}
            />
          </RightDrawer>
          : undefined
        }

        <ApolloTabs2 value={tabstate} setValue={setTabstate} tablabel={["未審査アイコン一覧", "審査済アイコン一覧"]}/>
        <ApolloTabPanel value={tabstate} index={0}>
          <ApolloDataTable
            title={""}
            data={unApprovedRows}
            columns={columns}
            options={options}
          ></ApolloDataTable>
        </ApolloTabPanel>
        <ApolloTabPanel value={tabstate} index={1}>
          <ApolloDataTable
            title={""}
            data={approvedRows}
            columns={columns}
            options={options2}
          ></ApolloDataTable>
        </ApolloTabPanel>
      </ApolloPageUsagePermission>
    </GenericTemplate>
  );
}
export default AdClientIconApprovalPage;
